export default {
  computed: {
    user() { return this.$store.state.user; },
    loading() { return this.$store.state.loading; },
    isManager() { return this.$store.getters.isManager; },
    isDealer() { return this.$store.getters.isDealer; },
    winners() { return this.$store.state.winners.winners; },
  },
  async created() {
    if (this.isDealer) {
      await this.$router.push('/dashboard');
    } else {
      this.user && await this.$store
        .dispatch('winners/GetWinners', this.user.profile_id);
    }
  },
};
